import React from 'react';
import './OrganizationHistory.css';
import { format } from 'date-fns';
import logComponent from '../../common/logComponent';

export default function OrganizationHistory({ organization }) {

  const { createdOn, createdBy, lastModifiedOn, lastModifiedBy } = organization;
  if (logComponent('OrganizationHistory')) { console.debug('OrganizationHistory rendered'); }

  return (
    <table className="Organization-History">
      <thead className="Organization-History__thead">
        <tr>
          <th className="Organization-History__heading Organization-History__action-heading">Action</th>
          <th className="Organization-History__heading Organization-date-heading">Date</th>
          <th className="Organization-History__heading Organization-user-heading">User</th>
        </tr>
      </thead>
      <tbody>
        <tr className="Organization-History__row">
          <td className="Organization-History__cell">Created</td>
          <td className="Organization-History__cell">{format(new Date(createdOn), 'dd-MMM-yyyy')}</td>
          <td className="Organization-History__cell">{createdBy}</td>
        </tr>
        <tr className="Organization-History__row">
          <td className="Organization-History__cell">Last Modified</td>
          <td className="Organization-History__cell">{format(new Date(lastModifiedOn), 'dd-MMM-yyyy')}</td>
          <td className="Organization-History__cell">{lastModifiedBy}</td>
        </tr>
      </tbody>
    </table>
  );
}